import styled from 'styled-components';
import checkMark from '../../assets/svg/icon-check-mark-white.svg';

const CheckBox = styled.input.attrs({
  type: 'checkbox',
})`
  &:checked,
  &:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  &:checked + label,
  &:not(:checked) + label {
    position: relative;
    padding-left: 32px;
    cursor: pointer;
    line-height: 26px;
    display: inline-block;
    color: ${p => p.theme.color.black};
  }

  &:checked + label:before,
  &:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 26px;
    height: 26px;
    border: 1px solid #ddd;
    border-radius: 3px;
    background: #fff;
  }

  &:checked + label:after,
  &:not(:checked) + label:after {
    content: '';
    width: 26px;
    height: 26px;
    background-color: ${p => p.theme.color.teal};
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 3px;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  &:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  &:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  &:checked + label:after {
    background-image: url(${checkMark});
    background-size: contain;
    background-position: center;
  }
`;

const Wrapper = styled.p`
  margin-bottom: ${p => p.theme.spacing(4)};

  &:last-child {
    margin-bottom: ${p => p.theme.spacing(12)};
  }
`;

export { Wrapper, CheckBox };



// WEBPACK FOOTER //
// ./src/components/CheckBoxes/styles.js